import React from 'react';
import PropTypes from 'prop-types';
import { useI18n } from 'hooks/use_i18n';
import isObject from 'lodash/isObject';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import has from 'lodash/has';
import ByLocale from 'components/ui/by_locale';
import SoftBadge from 'components/ui/soft_badge';
import { useSession } from 'hooks/use_context';

const DEFAULT_STATUS_COLOR = {
  pending: 'warning',
  pending_approval: 'warning',
  approved: 'success',
  rejected: 'danger',
  banned: 'danger',
  archived: 'secondary',
  disabled: 'danger',
  live: 'success',
  draft: 'info',
  coming_soon: 'primary',
  error: 'danger',
  deprecated: 'secondary',
};

const Status = ({ status, className, label, showSlug = false }) => {
  const { t } = useI18n();
  const { isProvider } = useSession();
  if (isNil(status)) {
    return null;
  }
  if (isObject(status) && has(status, 'provider_name_en')) {
    return (
      <SoftBadge data-cy={`status_${status.slug}`} className={`${className || ''}`} bg={status.color} pill>
        <ByLocale object={status} attribute={isProvider ? 'provider_name' : 'seller_name'} />
        {showSlug && <span className="ml-1">({status.slug})</span>}
      </SoftBadge>
    );
  }
  return (
    <SoftBadge data-cy={`status_${status}`} className={`${className || ''}`} bg={isString(status) ? DEFAULT_STATUS_COLOR[status] : status.color} pill>
      {label || t(`components.ui.status.${status}`)}
    </SoftBadge>
  );
};

Status.defaultProps = {
  label: '',
  className: '',
};

Status.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Status;
